module.exports = __webpack_public_path__ + "static/media/felix_arlindo_strottmann.821935d9.png";